import { useState } from 'react'
import { ClipType, CollaborationStatus } from '../../gql/types'
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonStyle,
  CollaborationStatus as CollaborationStatusComponent,
} from '..'
import { AcceptContentModal } from '../../brands/shared/AcceptContentModal'
import { RequestEditsButton } from './RequestEditsButton'

export const HeaderClip = ({ clip, type, className = '' }) => {
  const [isAcceptContentModalOpen, setIsAcceptContentModalOpen] =
    useState(false)

  return (
    <>
      <dl>
        <div className='grid grid-cols-2 gap-x-4'>
          <div className='col-span-1'>
            {type === 'brand' && (
              <RequestEditsButton clip={clip} type={type} className='' />
            )}
          </div>

          <div>
            <div className='my-1 text-sm text-gray-900 flex justify-end whitespace-nowrap'>
              {clip?.collaboration?.status !==
                CollaborationStatus.contentUploaded && (
                <CollaborationStatusComponent
                  status={clip.collaboration.status}
                  onProductShippingClick={() => {
                    if (clip.collaboration.productTrackingLink) {
                      window.open(
                        clip.collaboration.productTrackingLink,
                        '_blank',
                      )
                    }
                  }}
                />
              )}
              {clip?.collaboration?.status ===
                CollaborationStatus.contentUploaded &&
                (type === 'brand' && clip.type === ClipType.firstVersion ? (
                  <Button
                    title='Approve Content'
                    type='button'
                    styleType={ButtonStyle.fill}
                    size={ButtonSize.small}
                    colour={ButtonColor.primary}
                    onClick={() => {
                      setIsAcceptContentModalOpen(true)
                    }}
                  />
                ) : (
                  <CollaborationStatusComponent
                    status={clip.collaboration.status}
                    onProductShippingClick={() => {
                      if (clip.collaboration.productTrackingLink) {
                        window.open(
                          clip.collaboration.productTrackingLink,
                          '_blank',
                        )
                      }
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      </dl>

      {isAcceptContentModalOpen && (
        <AcceptContentModal
          collaboration={clip.collaboration}
          isOpen={isAcceptContentModalOpen}
          setIsOpen={setIsAcceptContentModalOpen}
        />
      )}
    </>
  )
}
